// extracted by mini-css-extract-plugin
export default {"cls1":"HfsUUp0yAgOycHF1QVq4","cls2":"VOgIDaNu0FPqFszl4syc HfsUUp0yAgOycHF1QVq4"};